import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import MarketingLink from "../../common/MarketingLink";
import SettingsService from "../../service/SettingsService";

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: {}
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        SettingsService.loadSettings(settings => this.updateSettings(settings));
    }

    handleChange(event) {
        const settings = this.state.settings;
        settings[event.target.name] = event.target.value;

        this.updateSettings(settings);
    }

    updateSettings(settings) {
        this.setState({
            settings: settings,
            isSlackValid: settings.slackAuthToken && settings.slackChannels
        });
    }

    render() {
        return (
            <div>
                <TopNav tab="connections"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 m-b-md">
                                <h1 className="page-header">Connections</h1>
                                <h4 className="text-muted">Connect your bot.</h4>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <p>This section controls how your bot connects to your services.
                                    It is important that your <i>Slack</i> settings
                                    are right, before setting up your other services.</p>
                            </div>
                        </div>

                        <div className="row m-t">
                            <div className="col-sm-10 col-md-8 col-lg-7">

                                <div className="panel with-nav-tabs panel-info">
                                    <div className="panel-heading" id="slack-panel-header">
                                        <ul className="nav nav-tabs">
                                            <li className="active"><a href="#settings-slack" data-toggle="tab">Slack <i
                                                id="settings-slack-tab-status"
                                                className={`icon ${typeof this.state.isSlackValid === 'undefined' ? 'icon-dots-three-horizontal' : (this.state.isSlackValid ? 'icon-check' : 'icon-warning')}`}/></a>
                                            </li>
                                            <li><a href="#settings-jenkins" data-toggle="tab">Jenkins</a>
                                            </li>
                                            <li><a href="#settings-rundeck" data-toggle="tab">Rundeck</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="panel-body">
                                        <div className="tab-content">

                                            <div className="tab-pane active" id="settings-slack">
                                                <div className={`form-group ${this.state.settings.slackAuthToken ? 'has-success' : 'has-error'}`}>
                                                    <label htmlFor="slackAuthToken">Slack Auth Token</label>
                                                    <input className="form-control" type="text"
                                                           name="slackAuthToken"
                                                           spellCheck="off"
                                                           onChange={this.handleChange}
                                                           value={this.state.settings.slackAuthToken || ''}
                                                           required=""/>
                                                    <div className="help-block">Your Slack bot auth token.
                                                        <MarketingLink
                                                            small={true} icon="info-with-circle"
                                                            href="/docs/bot/connections">Show me</MarketingLink>
                                                    </div>
                                                </div>
                                                <div className={`form-group ${this.state.settings.slackChannels ? 'has-success' : 'has-error'}`}>
                                                    <label htmlFor="slackChannels">Slack Channels</label>
                                                    <input className="form-control" type="text"
                                                           name="slackChannels"
                                                           spellCheck="off"
                                                           onChange={this.handleChange}
                                                           value={this.state.settings.slackChannels || ''}
                                                           required=""
                                                           placeholder="channel-name"/>
                                                    <div className="help-block">The (comma separated) channels in which
                                                        to listen for commands.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="tab-pane" id="settings-jenkins">
                                                <div className="form-group">
                                                    <label htmlFor="jenkinsBaseUrl">Jenkins Base URL</label>
                                                    <input className="form-control" type="text"
                                                           spellCheck="off"
                                                           name="jenkinsBaseUrl"
                                                           onChange={this.handleChange}
                                                           required="" value={this.state.settings.jenkinsBaseUrl || ''}
                                                           placeholder="http://my-jenkins-server:8080/"/>
                                                    <div className="help-block">The base URL for your Jenkins server.
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="jenkinsApiToken">Jenkins API Token</label>
                                                    <input className="form-control" type="text"
                                                           spellCheck="off"
                                                           name="jenkinsApiToken"
                                                           onChange={this.handleChange}
                                                           required="" value={this.state.settings.jenkinsApiToken || ''}/>
                                                    <div className="help-block">The API token for Jenkins.</div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="jenkinsUsername">Jenkins Username</label>
                                                    <input className="form-control" type="text"
                                                           spellCheck="off"
                                                           name="jenkinsUsername"
                                                           onChange={this.handleChange}
                                                           required="" value={this.state.settings.jenkinsUsername || ''}
                                                           autoComplete="off"/>
                                                    <div className="help-block">The username for Jenkins.</div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="jenkinsPassword">Jenkins Password</label>
                                                    <input className="form-control" type="password"
                                                           name="jenkinsPassword"
                                                           onChange={this.handleChange}
                                                           required="" value={this.state.settings.jenkinsPassword || ''}
                                                           autoComplete="off"/>
                                                    <div className="help-block">The password for Jenkins.</div>
                                                </div>
                                            </div>

                                            <div className="tab-pane" id="settings-rundeck">
                                                <div className="form-group">
                                                    <label htmlFor="rundeckBaseUrl">Rundeck Base URL</label>
                                                    <input className="form-control" type="text"
                                                           spellCheck="off"
                                                           name="rundeckBaseUrl"
                                                           onChange={this.handleChange}
                                                           required="" value={this.state.settings.rundeckBaseUrl || ''}
                                                           placeholder="http://my-rundeck-server:4444/"/>
                                                    <div className="help-block">The base URL for your Rundeck server.
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="rundeckApiToken">Rundeck API Token</label>
                                                    <input className="form-control" type="text"
                                                           spellCheck="off"
                                                           name="rundeckApiToken"
                                                           onChange={this.handleChange}
                                                           required="" value={this.state.settings.rundeckApiToken || ''}/>
                                                    <div className="help-block">The API token for Rundeck.
                                                        <MarketingLink
                                                            small={true} icon="info-with-circle"
                                                            href="/docs/bot/connections">Show me</MarketingLink></div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <button onClick={() => SettingsService.saveSettings(this.state.settings)}
                                                    className="btn btn-primary btn-block">Save
                                            </button>
                                        </div>
                                        <div className="col-sm-6 m-t-sm-c-xs">
                                            <Link className="btn btn-default btn-block" to="/dashboard">Cancel</Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/modules/views/bot/Connections.js